export default "__VITE_ASSET__2G46hfba__"